<template>
  <div v-if="visible" class="p-4">
    <h4 class="mb-3">Vorlage auswählen</h4>
    <p class="text-muted mb-4">
      Wähle, ob du manuell erstellen oder eine Vorlage verwenden möchtest.
    </p>

    <!-- Choice Cards -->
    <div class="row g-3 mb-5">
      <div class="col-md-6">
        <div
          class="template-card"
          :class="{ selected: !selectedDraft }"
          @click="selectManualCreation"
        >
          <div class="template-card-header">
            <div class="template-card-icon">
              <font-awesome-icon icon="edit" />
            </div>
            <h6 class="mb-1">Manuell erstellen</h6>
          </div>
          <p class="template-card-description">
            Erstelle eine neue Quittung von Grund auf und fülle alle Felder manuell aus.
          </p>
        </div>
      </div>

      <div class="col-md-6">
        <div
          class="template-card"
          :class="{ selected: !!selectedDraft }"
          @click="openDraftModal"
        >
          <div class="template-card-header">
            <div class="template-card-icon">
              <font-awesome-icon icon="file-alt" />
            </div>
            <h6 class="mb-1">Aus Vorlage erstellen</h6>
          </div>
          <p class="template-card-description">
            Verwende eine gespeicherte Vorlage als Basis für deine neue Quittung.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { ReceiptWizardSymbol } from '../../tokens'

const wizard = inject(ReceiptWizardSymbol)

if (!wizard) {
  throw new Error('StepDraftSelection requires ReceiptWizard context')
}

const visible = computed(() => wizard.isCurrentStep('Vorlage') && wizard.hasAvailableDrafts.value)
const selectedDraft = wizard.selectedDraft
const selectManualCreation = wizard.selectManualCreation

const openDraftModal = () => {
  wizard.showDraftSelection.value = true
}
</script>
